<template>
  <div>
    <div class="d-flex align-items-center justify-content-between">
      <h4 class="">
        <feather-icon class="align-middle" size="20" icon="GridIcon" />
        العقارات
      </h4>
      <b-button
        variant="success"
        @click="onAddClicked"
        v-can="{ slug: $route.meta.slug, action: 'C' }"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        إضافة عقار
      </b-button>
    </div>
    <hr />
    <data-table
      ref="estatesTable"
      ep="v2/real-estates"
      :fields="fields"
      v-can="{ slug: $route.meta.slug, action: 'S' }"
    >
      <template #cell(estate_document)="{ item }">
        <b-button
          target="_blank"
          rel="noopener noreferrer"
          :to="{ name: 'file-view', query: { ep: item.estate_document } }"
          variant="flat-info"
          size="sm"
        >
          <div class="d-flex">
            <feather-icon class="mr-50" icon="EyeIcon" size="16" />
            عرض
          </div>
        </b-button>
      </template>
      <template #cell(actions)="row">
        <div class="d-flex justify-content-center align-items-center">
          <div>
            <b-badge variant="light-danger" v-if="!row.item.is_operating">
              غير موضوع بالخدمة
            </b-badge>
          </div>
          <!-- <div> -->
            <b-badge
              v-if='row.item.old_ngo_id'
              pill
              variant="light-primary"
            >
              منقول من المنظمة المندمجة
            </b-badge>
            <b-badge
              v-if='row.item.international_donation_id'
              pill
              variant="light-secondary"
            >
                تبرع خارجي
            </b-badge>
            <b-badge
              v-if='row.item.national_donation_id'
              pill
              variant="light-success"
            >
                تبرع داخلي
            </b-badge>
          <!-- </div> -->
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-can="{ slug: $route.meta.slug, action: 'U' }"
              @click="onUpdateClicked(row.item)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">تعديل</span>
            </b-dropdown-item>

            <b-dropdown-item
              @click="onDelete(row.item.id)"
              v-can="{ slug: $route.meta.slug, action: 'D' }"
            >
              <feather-icon icon="Trash2Icon" />
              <span class="align-middle ml-50">حذف</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </data-table>
    <form-modal
      ref="estateModal"
      :formSchema="estatesFormSchema"
      title="معلومات العقار"
      v-model="formModal"
      :loading="loading"
      @confirm="onModalConfirmed"
    >
      <template #estate_document="{ form }">
        <form-file-input
          placeholder="اختر ملفاً"
          id="document"
          label="وثيقة العقار"
          accept=".doc,.pdf,.docx"
          v-model="form.estate_document"
          rules="required"
          :key="formModal"
        />
      </template>
    </form-modal>
  </div>
</template>

<script>
import dataTable from "@/components/data-table";
import {
  BButton,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormFile,
} from "bootstrap-vue";
import * as ep from "../../endpoints";
import FormModal from "@/components/FormModal.vue";
import FormFileInput from "@/components/FormFileInput.vue";

import { mapActions, mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    dataTable,
    BDropdown,
    BDropdownItem,
    BButton,
    BBadge,
    FormModal,
    BFormFile,
    FormFileInput,
  },
  methods: {
    ...mapActions("Properties", [
      "addProperty",
      "updateProperty",
      "deleteProperty",
    ]),
    onUpdateClicked(form) {
      this.isEdit = true;
      var toUpdate = {
        id: form.id,
        number: form.number,
        region: form.region,
        governorate_id: form.governorate.id,
        possessive_form_id: form.possessiveForm.id,
        estate_type_id: form.estateType.id,
        is_operating: form.is_operating,
        estate_document: form.estate_document,
      };
      this.$refs.estateModal.init(toUpdate);
      this.formModal = true;
    },
    onAddClicked() {
      this.isEdit = false;
      this.$refs.estateModal.init({});
      this.formModal = true;
    },
    onDelete(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف العقار؟", {
          title: "تأكيد حذف العقار",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.deleteProperty({ ep: ep.REALESTATES_BY_ID(id) }).then(() => {
              this.$refs.estatesTable.refreshTable();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "تم الحذف بنجاح",
                  icon: "CheckSquareIcon",
                  variant: "success",
                },
              });
            });
        });
    },
    setDoc(e, form) {
      form.estate_document = e;
    },
    async onModalConfirmed(form) {
      if (form.id) {
        const toUpdate = { ...form };
        if (typeof toUpdate.estate_document === "string")
          delete toUpdate.estate_document;
        await this.updateProperty({
          ep: ep.REALESTATES_BY_ID(toUpdate.id),
          form: toUpdate,
        }).then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "تم تعديل معلومات العقار بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
              timeout: 3000,
            },
          });
          this.$refs.estatesTable.refreshTable();
        });
      } else
        await this.addProperty({ ep: ep.REALESTATES, form: form }).then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "تمت إضافة العقار بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
              timeout: 3000,
            },
          });
          this.$refs.estatesTable.refreshTable();
        });

      this.formModal = false;
    },
  },
  data() {
    return {
      formModal: false,
      isEdit: false,
      estatesFormSchema: {
        number: {
          component: "FormInput",
          key: "number",
          attrs: {
            label: "رقم العقار",
            rules: "required",
          },
        },
        estate_type_id: {
          component: "FormSelect",
          key: "estate_type_id",
          attrs: {
            id: "estateType",
            label: "نوع العقار",
            rules: "required",
            ep: "v2/selects/estate-types",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
          },
        },
        region: {
          component: "FormInput",
          key: "region",
          attrs: {
            label: "المنطقة الإدارية",
            rules: "required",
          },
        },
        governorate_id: {
          component: "FormSelect",
          key: "governorate_id",
          attrs: {
            id: "estates-gov",
            label: "المحافظة",
            ep: "v2/selects/governorates",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            rules: "required",
          },
        },
        possessive_form_id: {
          component: "FormSelect",
          key: "possessive_form_id",
          attrs: {
            id: "possiveForm",
            label: "صيغة التملك",
            rules: "required",
            ep: "v2/selects/possessive-forms",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
          },
        },
        is_operating: {
          component: "FormSelect",
          key: "is_operating",
          attrs: {
            id: "is-operating",
            label: "موضوع بالخدمة",
            rules: "required",
            options: [
              {
                text: "نعم",
                value: 1,
              },
              {
                text: "لا",
                value: 0,
              },
            ],
            reduce: (x) => x.value,
            getOptionLabel: (x) => x.text,
          },
        },

        estate_document: {
          key: "estate_document",
        },
      },
      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        { key: "number", label: "رقم العقار", sortable: true },
        { key: "region", label: "المنطقة الإدارية", sortable: true },
        {
          key: "governorate.name_ar",
          label: "المحافظة",
          sortable: true,
        },
        {
          key: "estateType.name_ar",
          label: "نوع حيازة العقار",
        },
        { key: "possessiveForm.name_ar", label: "صيغة التملك" },
        { key: "estate_document", label: "وثيقة العقار" },
        { key: "actions", label: " " },
      ],
    };
  },
  computed: {
    ...mapGetters("Properties", ["loading"]),
  },
};
</script>
